import { render } from "./polygon-contact.vue?vue&type=template&id=2e7676ec&scoped=true&ts=true"
import script from "./polygon-contact.vue?vue&type=script&lang=ts"
export * from "./polygon-contact.vue?vue&type=script&lang=ts"

import "./polygon-contact.vue?vue&type=style&index=0&id=2e7676ec&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\2\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7676ec"]])

export default __exports__